import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { useCallback, useMemo } from "react";
import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../hooks/storeHooks";
import { selectSectionTitles } from "../../store/selectors/checklistSelectors";

/**
 * Section filter for the Checklist Review table: a dropdown of all
 * sections in the loaded checklist. "All sections" maps to a null filter
 * value, which PrimeReact treats as "no filter".
 */
export const SectionFilter = (options: ColumnFilterElementTemplateOptions) => {
    const { t } = useTranslation("locale");
    const sectionTitles = useAppSelector(selectSectionTitles);

    const sectionOptions = useMemo(() => [
        { label: t("answers.table.allSections"), value: null },
        ...sectionTitles.map((title) => ({ label: title, value: title })),
    ], [t, sectionTitles]);

    const onChange = useCallback((event: DropdownChangeEvent) => (
        options.filterApplyCallback(event.value ?? null)
    ), [options]);

    return (
        <Dropdown
            value={options.value}
            options={sectionOptions}
            onChange={onChange}
            filter
            showClear
            placeholder={t("answers.table.allSections")}
            scrollHeight="400px"
            className="large-filter"
        />
    );
};
